import { Order } from 'entities/orders';
import { FC } from 'react';
import { formatWithLocale } from 'shared/lib/datepicker';
import { Typography } from 'shared/ui/typography';
import calendarIcon from 'shared/assets/icons/calendar-icon.svg';

interface OrderVisitDateProps {
	order: Order;
	includeCalendarIcon?: boolean;
}

export const OrderVisitDate: FC<OrderVisitDateProps> = ({
	order,
	includeCalendarIcon = false,
}) => {
	return (
		<Typography
			icon={
				includeCalendarIcon
					? { src: calendarIcon, size: 'small' }
					: undefined
			}
			pointer={true}
		>
			{formatWithLocale(new Date(order.dt_start), 'dd.MM.yyyy')}
		</Typography>
	);
};
